import { RemoteGetStudentsIndividualWorkloadReport } from 'data/usecases';
import { GetStudentsIndividualWorkloadReportUseCaseInterface } from 'domain/usecases';
import { makeApiUrlStudentsIndividualWorkloadReport } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeStudentsIndividualWorkloadReport =
  (): GetStudentsIndividualWorkloadReportUseCaseInterface =>
    new RemoteGetStudentsIndividualWorkloadReport(
      makeApiUrlStudentsIndividualWorkloadReport(),
      makeAxiosHttpClient(),
    );
